module.exports = __webpack_public_path__ + "static/media/biopharmachem-ireland.3a9d9b4b.jpg";